export default __webpack_public_path__ + "static/media/Notification-and-Apllication-form-for-felowship-course-2025-26.86968534.pdf";